import {
  post,
  get,
  post_OSS,
  post_blob,
  post_arraybuffer,
  post_query,
} from "@/axios";

/** 获取修复选项 */
export const getRepairOptionEnum = function (params) {
  return get("/wms/repairRecord/getRepairOptionEnum", params);
};

/** 状态统计 */
export const statusCount = function (params) {
  return get("/wms/repairRecord/statusCount", params);
};

/** 废弃 */
export const repairRecordDiscard = function (params) {
  return post("/wms/repairRecord/discard", params);
};

/** 编辑 */
export const repairRecordUpdate = function (params) {
  return post("/wms/repairRecord/update", params);
};

/** 列表查询 */
export const repairRecordPage = function (params) {
  return post("/wms/repairRecord/page", params);
};

/** 导出 */
export const repairRecordExport = function (params) {
  return post("/wms/repairRecord/export", params);
};





